var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPlusMinus = function SvgIconPlusMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 2a1 1 0 0 1 1 1v2.75h2.75a1 1 0 1 1 0 2H7.75v2.75a1 1 0 1 1-2 0V7.75H3a1 1 0 0 1 0-2h2.75V3a1 1 0 0 1 1-1M19.457 5.957a1 1 0 0 0-1.414-1.414l-13.5 13.5a1 1 0 1 0 1.414 1.414zM13.5 16.25a1 1 0 1 0 0 2H21a1 1 0 1 0 0-2z"
  }))));
};
export default SvgIconPlusMinus;